module.exports = __webpack_public_path__ + "static/media/funitures8.97f8b72e.svg";